import { BadgeCheck, Camera, Layers } from "lucide-react";

const chip = "rounded-full bg-slate-900/5 px-2 py-0.5 text-[11px] text-slate-700";

export function CardFacts({ card }) {
  const flags = [card.rookie && "Rookie", card.autograph && "Auto", card.relic && "Relic/Patch", card.serial && `#${card.serial}`].filter(Boolean);
  const facts = [card.year, card.manufacturer, card.set, card.card_number && `#${card.card_number}`, card.parallel, card.rarity, card.team].filter(Boolean);
  return (
    <div className="space-y-1.5" data-testid="card-facts">
      <p className="text-sm font-semibold text-slate-900" data-testid="card-subject">{card.subject}{card.game ? <span className="font-normal text-slate-500"> · {card.game}</span> : null}</p>
      <div className="flex flex-wrap gap-1">
        {facts.map((f, i) => <span key={i} className={chip}>{f}</span>)}
        {flags.map((f) => <span key={f} className="rounded-full bg-amber-100 px-2 py-0.5 text-[11px] font-semibold text-amber-900" data-testid={`card-flag-${f.replace(/[^a-z]/gi, "").toLowerCase() || "serial"}`}>{f}</span>)}
      </div>
    </div>
  );
}

export function CardCondition({ card }) {
  if (card.graded) {
    const g = card.graded;
    return (
      <p className="flex items-center gap-1.5 rounded-md bg-blue-50 p-2 text-xs text-blue-900" data-testid="card-graded">
        <BadgeCheck className="h-4 w-4" /> Graded <b>{g.company} {g.grade}</b>{g.cert ? <span className="font-mono text-[11px]"> · cert {g.cert}</span> : null}
      </p>
    );
  }
  const n = card.condition_notes || {};
  return (
    <div className="rounded-md border border-slate-200 bg-white p-2" data-testid="card-raw-condition">
      <p className="flex flex-wrap items-center gap-x-2 text-xs text-slate-800">
        <Layers className="h-3.5 w-3.5 text-slate-500" /> Raw · {card.raw_condition || "Ungraded"}
        {card.est_grade && (
          <span className="rounded-full bg-violet-50 px-2 py-0.5 text-[11px] font-semibold text-violet-700" data-testid="card-est-grade">
            Likely PSA {card.est_grade.low === card.est_grade.high ? card.est_grade.low : `${card.est_grade.low}–${card.est_grade.high}`} · estimate
          </span>
        )}
      </p>
      {Object.keys(n).length > 0 && (
        <dl className="mt-1.5 grid grid-cols-1 gap-x-3 gap-y-0.5 text-[11px] text-slate-600 min-[440px]:grid-cols-2" data-testid="card-condition-notes">
          {["corners", "edges", "surface", "centering"].filter((k) => n[k]).map((k) => (
            <div key={k} className="min-w-0"><dt className="inline font-semibold capitalize text-slate-700">{k}: </dt><dd className="inline">{n[k]}</dd></div>
          ))}
        </dl>
      )}
    </div>
  );
}

export function CardPhotoTips({ tips }) {
  if (!tips?.length) return null;
  return (
    <div className="rounded-md border border-amber-200 bg-amber-50 p-2" data-testid="card-photo-tips">
      <p className="mb-1 flex items-center gap-1 text-[11px] font-semibold text-amber-900"><Camera className="h-3 w-3" /> Add these photos for a stronger listing</p>
      <ul className="list-disc space-y-0.5 pl-4 text-[11px] text-amber-900">
        {tips.map((t, i) => <li key={i} data-testid={`card-photo-tip-${i}`}>{t}</li>)}
      </ul>
    </div>
  );
}
